import React from 'react';
import InvitationEvaluationTable from './InvitationEvaluationTable';

const ProductHydroTable = ({ refreshTrigger }) => (
  <InvitationEvaluationTable
    procurementTypeHeader='1'
    refreshTrigger={refreshTrigger}
  />
);

export default React.memo(ProductHydroTable);
